// extracted by mini-css-extract-plugin
module.exports = {"container":"FullDealEntryPointForm_container__3iOKj","input":"FullDealEntryPointForm_input__369vg","inputLabels":"FullDealEntryPointForm_inputLabels__2-k5a"};